import { forwardRef, type Ref, type SVGProps } from "react";
const IconPlayFilledSVG = ({
  children,
  ...rest
}: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 32 32" ref={ref} {...rest}>{children}<path fill="currentColor" d="M27 14.3 7 2.3A2 2 0 0 0 4 4v24a2 2 0 0 0 3 1.7l20-12a2 2 0 0 0 0-3.4" /></svg>;
const ForwardRef = forwardRef(IconPlayFilledSVG);
ForwardRef.displayName = "IconPlayFilled";
export { ForwardRef as IconPlayFilled };